import React, { useState, useEffect, useCallback } from 'react'
import moment from 'moment'
import { useParams, useNavigate } from 'react-router-dom'

import TextField from '../../../components/textfield/TextField.jsx'
import SelectBox from '../../../components/selectbox/SelectBox.jsx'
import FileUpload from '../../../components/file.upload/fileupload.jsx'
import RadioButton from '../../../components/radiobutton/radiobutton.jsx'
import { Button } from '../../../../components/common'
import { useFetchLearningForm } from './api'
import { useFetchProgramDetails, useCreateBooking } from './api'
import { useAuthStore } from '../../../../store/authStore'

function EDCRegistration() {
  const [formdata, setFormdata] = useState({})
  const [fileNames, setFileNames] = useState({})
  const [fees, setFees] = useState({
    res: null,
    nonres: null,
    sc: null,
    st: null,
  })
  const [programs, setPrograms] = useState({})
  const [step, setStep] = useState(1)
  const [errors, setErrors] = useState({})
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [submittingId, setSubmittingId] = useState(null)
  const { id } = useParams()
  const { userData } = useAuthStore()
  const navigate = useNavigate()

  const handleTextFieldChange = (value, name) => {
    setFormdata((prev) => ({ ...prev, [String(name)]: value }))
    // Clear error for this field when user starts typing
    if (errors[String(name)]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[String(name)]
        return newErrors
      })
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    const fieldName = e.target.name
    if (file) {
      setFormdata((prev) => ({ ...prev, [fieldName]: file }))
      setFileNames((prev) => ({ ...prev, [fieldName]: file.name }))
    }
    // Clear error for this field when user selects a file
    if (errors[fieldName]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[fieldName]
        return newErrors
      })
    }
  }

  const handleFileRemove = (fieldName) => {
    setFormdata((prev) => {
      const newFormdata = { ...prev }
      delete newFormdata[fieldName]
      return newFormdata
    })
    setFileNames((prev) => {
      const newFileNames = { ...prev }
      delete newFileNames[fieldName]
      return newFileNames
    })
  }

  const calculateFees = useCallback((program) => {
    console.log('Program data:', program)
    console.log('res_fees:', program.res_fees, 'type:', typeof program.res_fees)
    console.log(
      'non_res_fees:',
      program.non_res_fees,
      'type:',
      typeof program.non_res_fees
    )
    console.log('sc_fees:', program.sc_fees, 'type:', typeof program.sc_fees)
    console.log('st_fees:', program.st_fees, 'type:', typeof program.st_fees)

    const today = moment()
    const isEarlyBird =
      program.early_bird_date &&
      today.isSameOrBefore(moment(program.early_bird_date))
    const discountRate = program.discount
      ? 1 - Number(program.discount) / 100
      : 1

    const applyDiscount = (fee) => {
      const numericFee = Number(fee)
      return isEarlyBird && program.discount
        ? numericFee * discountRate
        : numericFee
    }

    const calculatedFees = {
      res:
        program.res_fees && Number(program.res_fees) > 0
          ? applyDiscount(program.res_fees)
          : null,
      nonres:
        program.non_res_fees && Number(program.non_res_fees) > 0
          ? applyDiscount(program.non_res_fees)
          : null,
      sc:
        program.sc_fees && Number(program.sc_fees) > 0
          ? applyDiscount(program.sc_fees)
          : null,
      st:
        program.st_fees && Number(program.st_fees) > 0
          ? applyDiscount(program.st_fees)
          : null,
    }

    console.log('Calculated fees:', calculatedFees)
    setFees(calculatedFees)
  }, [])

  const { data } = useFetchLearningForm(id)
  const { data: programData } = useFetchProgramDetails(id)

  useEffect(() => {
    if (programData) {
      setPrograms(programData)
      calculateFees(programData)
    }
  }, [programData, calculateFees])

  const validateForm = () => {
    const newErrors = {}

    data?.forEach((item) => {
      if (item.mandatory === 1) {
        const value = formdata[item.id]
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          newErrors[item.id] = `Field is required`
        }
      }
    })

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleNext = () => {
    if (submittingId === 'next') return
    if (validateForm()) {
      // Check if all fees are null or 0
      const hasValidFees = fees.res || fees.nonres || fees.sc || fees.st

      if (hasValidFees) {
        // Has fees, go to step 2 (fees page)
        setStep(2)
      } else {
        // No fees, submit directly
        handleSubmit('res') // Use 'res' as default fee type (will be null)
      }
    }
  }

  const handleSubmit = (feeType) => {
    if (submittingId === feeType) return
    console.log('Current formdata:', formdata)
    console.log('Formdata keys:', Object.keys(formdata))

    // Get the fee amount (will be 0 if no fees, or the actual fee amount)
    const feeAmount = fees[feeType] || 0

    // Send formdata directly with question IDs as keys
    const bookingData = {
      user_id: userData?.id,
      program_id: id,
      fees: feeAmount,
      responses: formdata, // Send the object with question ID keys
    }

    console.log('Submitting booking data:', bookingData)
    console.log('User data:', userData)
    console.log('User ID:', userData?.id)
    console.log('Program ID:', id)
    console.log('Selected fee type:', feeType)
    console.log('Fee amount:', feeAmount)
    console.log('Fees object:', fees)

    setSubmittingId(feeType)
    mutate(bookingData, {
      onSettled: () => {
        setSubmittingId(null)
      },
    })
  }

  const { mutate } = useCreateBooking(() => {
    // Handle success - show custom success modal
    console.log('Booking successful!')
    setShowSuccessModal(true)
  })

  const genInput = (item) => {
    const parsedOptions = Array.isArray(item.options)
      ? item.options.map((opt) =>
          typeof opt === 'string' ? { name: opt } : opt
        )
      : JSON.parse(item.options || '[]').map((opt) =>
          typeof opt === 'string' ? { name: opt } : opt
        )

    const commonProps = {
      label: item.question_text,
      required: item.mandatory === 1,
      name: item.id,
    }

    switch (item.answer_type) {
      case 'text':
        return (
          <div className="flex flex-col space-y-2">
            <TextField
              {...commonProps}
              value={formdata[item.id] ?? ''}
              onChange={(value) => handleTextFieldChange(value, item.id)}
            />
          </div>
        )
      case 'radio':
        return (
          <div className="flex flex-col space-y-2">
            <RadioButton
              {...commonProps}
              value={formdata[item.id] ?? ''}
              options={parsedOptions}
              onChange={(value) => handleTextFieldChange(value, item.id)}
            />
          </div>
        )
      case 'select':
        return (
          <div className="flex flex-col space-y-2">
            <SelectBox
              {...commonProps}
              value={formdata[item.id] ?? ''}
              options={parsedOptions}
              handleChange={(e) =>
                handleTextFieldChange(e.target.value, item.id)
              }
            />
          </div>
        )
      case 'file':
        return (
          <div className="flex flex-col space-y-2">
            <FileUpload
              {...commonProps}
              value={formdata[item.id] ?? undefined}
              fileName={fileNames[item.id] || ''}
              onChange={handleFileChange}
              onRemove={() => handleFileRemove(item.id)}
            />
          </div>
        )
      default:
        return null
    }
  }

  const FeeBlock = ({ type, label, desc, originalFee }) => {
    const discountedFee = fees[type]
    const discountPercentage = programs.discount
    const showDiscount =
      originalFee && discountPercentage && originalFee !== discountedFee

    return (
      discountedFee && (
        <div className="bg-white rounded-lg shadow-md p-6 w-full sm:w-64 hover:shadow-xl transition-shadow duration-300">
          <h2 className="text-xl font-semibold text-blue-600 mb-2 text-center">
            {label}
          </h2>
          <p className="text-sm text-gray-500 text-center mb-4">{desc}</p>
          {showDiscount && (
            <div className="text-center mb-2">
              <p className="text-gray-400 line-through">₹ {originalFee}</p>
              <p className="text-green-600 font-bold">
                {discountPercentage}% off
              </p>
            </div>
          )}
          <h3 className="text-2xl font-bold text-center mb-4">
            ₹ {parseFloat(discountedFee).toFixed(2)}
          </h3>
          <div className="text-center">
            <Button
              secondary
              small
              className="w-full bg-linear-orange hover:bg-blue-600 text-white font-medium"
              label={submittingId === type ? 'Submitting...' : 'Submit'}
              disabled={submittingId === type}
              onClick={() => {
                console.log('Button clicked for type:', type)
                handleSubmit(type)
              }}
            />
          </div>
        </div>
      )
    )
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="p-8">
          <h1 className="text-3xl font-bold text-center text-blue-700 mb-8">
            Program Registration
          </h1>

          {step === 1 && (
            <>
              <div className="grid grid-cols-1 gap-6 mb-8">
                {data?.map((item, i) => (
                  <div key={i}>
                    {genInput(item)}
                    {errors[item.id] && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors[item.id]}
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex justify-center">
                <Button
                  primary
                  size="lg"
                  onClick={handleNext}
                  disabled={submittingId === 'next'}
                  className={`bg-blue-600 hover:bg-blue-700 text-white rounded-md shadow px-6 ${submittingId === 'next' ? 'opacity-70 cursor-not-allowed' : ''}`}
                  label={
                    submittingId === 'next'
                      ? 'Submitting...'
                      : fees.res || fees.nonres || fees.sc || fees.st
                        ? 'Next'
                        : 'Submit'
                  }
                />
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <div className="flex justify-between items-center mb-6">
                <div
                  onClick={() => setStep(1)}
                  className="text-blue-600 hover:underline cursor-pointer"
                >
                  &larr; Back
                </div>
              </div>
              <div className="flex flex-wrap justify-center gap-6">
                {fees.res && (
                  <FeeBlock
                    type="res"
                    label="Resident Fees"
                    desc="Pay the fees for resident category."
                    originalFee={programs.res_fees}
                  />
                )}
                {fees.nonres && (
                  <FeeBlock
                    type="nonres"
                    label="Normal Fees"
                    desc="Pay the fees for general category."
                    originalFee={programs.non_res_fees}
                  />
                )}
                {fees.sc && (
                  <FeeBlock
                    type="sc"
                    label="SC Fees"
                    desc="Pay the fees for SC category."
                    originalFee={programs.sc_fees}
                  />
                )}
                {fees.st && (
                  <FeeBlock
                    type="st"
                    label="ST Fees"
                    desc="Pay the fees for ST category."
                    originalFee={programs.st_fees}
                  />
                )}
                {!fees.res && !fees.nonres && !fees.sc && !fees.st && (
                  <div className="text-center py-8">
                    <p className="text-gray-600">
                      No fees applicable for this program.
                    </p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 backdrop-blur-md bg-white/20 flex items-center justify-center z-50 animate-fade-in">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 transform transition-all duration-300 ease-out scale-100 shadow-2xl border border-gray-100">
            <div className="text-center">
              {/* Animated Success Icon */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-r from-green-400 to-green-600 mb-6 animate-bounce-in">
                <svg
                  className="h-8 w-8 text-white animate-checkmark"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>

              {/* Success Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3 animate-slide-up">
                Successfully Registered!
              </h3>

              {/* Success Message */}
              <p className="text-gray-600 mb-8 animate-slide-up-delay">
                Program Coordinator will contact you soon.
              </p>

              {/* OK Button */}
              <div className="flex justify-center animate-slide-up-delay-2">
                <Button
                  label="OK"
                  className="w-[200px] bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 text-[20px]"
                  onClick={() => {
                    setShowSuccessModal(false)
                    navigate('/') // Navigate to home page
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EDCRegistration
